import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-psychological-abuse-form-signature',
  templateUrl: './psychological-abuse-form.component.html',
  styleUrls: ['./psychological-abuse-form.component.scss'],
})
export class PsychologicalAbuseFormComponent implements OnInit {
  psychologicalAbuseForm: FormGroup;
  @Output() hasValidPsychologicalAbuse = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  nullControls: string[] = [
    'HasInsulted', 'HasInsultedOther', 'HasInsultedWithChild',
    'HasInterrupt', 'HasInterruptOther', 'HasInterruptWithChild',
    'HasThreatenedLeave', 'HasThreatenedLeaveOther', 'HasThreatenedLeaveWithChild',
    'HasThreatenedMoney', 'HasThreatenedMoneyOther', 'HasThreatenedMoneyWithChild',
    'HasNoContact', 'HasNoContactOther', 'HasNoContactWithChild',
    'HasLocked', 'HasLockedOther', 'HasLockedWithChild',
    'HasWhereabouts', 'HasWhereaboutsOther', 'HasWhereaboutsWithChild',
    'HasDisabledCar', 'HasDisabledCarOther', 'HasDisabledCarWithChild',
    'HasThreatenedFamily', 'HasThreatenedFamilyOther', 'HasThreatenedFamilyWithChild',
    'HasThreatenedKidnap', 'HasThreatenedKidnapOther', 'HasThreatenedKidnapWithChild',
    'HasThreatenedParty', 'HasThreatenedPartyOther', 'HasThreatenedPartyWithChild'
  ];

  violenceETypes = [
    { label: 'Insulted or swore at', labelSpanish: 'Insultado/a o insultado/a', controls: { has: 'HasInsulted', hasOther: 'HasInsultedOther', withChild: 'HasInsultedWithChild', times: 'InsultedTimes', timesPrior: 'InsultedTimesPrior' } },
    { label: 'Interrupted eating or sleeping', labelSpanish: 'Comer o dormir interrumpido', controls: { has: 'HasInterrupt', hasOther: 'HasInterruptOther', withChild: 'HasInterruptWithChild', times: 'InterruptTimes', timesPrior: 'InterruptTimesPrior' } },
    { label: 'Threatened to leave the relationship', labelSpanish: 'Amenazado con dejar la relación', controls: { has: 'HasThreatenedLeave', hasOther: 'HasThreatenedLeaveOther', withChild: 'HasThreatenedLeaveWithChild', times: 'ThreatenedLeaveTimes', timesPrior: 'ThreatenedLeaveTimesPrior' } },
    { label: 'Made threats to withhold money', labelSpanish: 'Amenazó con retener el dinero', controls: { has: 'HasThreatenedMoney', hasOther: 'HasThreatenedMoneyOther', withChild: 'HasThreatenedMoneyWithChild', times: 'ThreatenedMoneyTimes', timesPrior: 'ThreatenedMoneyTimesPrior' } },
    { label: 'Did not permit contacts w/family or friends', labelSpanish: 'No permitía contactos con familiares o amigos', controls: { has: 'HasNoContact', hasOther: 'HasNoContactOther', withChild: 'HasNoContactWithChild', times: 'NoContactTimes', timesPrior: 'NoContactTimesPrior' } },
    { label: 'Locked in or out of house', labelSpanish: 'Encerrada adentro o fuera de la casa', controls: { has: 'HasLocked', hasOther: 'HasLockedOther', withChild: 'HasLockedWithChild', times: 'LockedTimes', timesPrior: 'LockedTimesPrior' } },
  ];
  violenceOTypes = [
    { label: 'Demanded constant knowledge of whereabouts', labelSpanish: 'Exigió conocimiento constante del paradero', controls: { has: 'HasWhereabouts', hasOther: 'HasWhereaboutsOther', withChild: 'HasWhereaboutsWithChild', times: 'WhereaboutsTimes', timesPrior: 'WhereaboutsTimesPrior' } },
    { label: 'Disabled car or withheld car keys', labelSpanish: 'Coche averiado o llaves del coche retenidas', controls: { has: 'HasDisabledCar', hasOther: 'HasDisabledCarOther', withChild: 'HasDisabledCarWithChild', times: 'DisabledCarTimes', timesPrior: 'DisabledCarTimesPrior' } },
    { label: 'Threatened family or friends', labelSpanish: 'Familiares o amigos amenazados', controls: { has: 'HasThreatenedFamily', hasOther: 'HasThreatenedFamilyOther', withChild: 'HasThreatenedFamilyWithChild', times: 'ThreatenedFamilyTimes', timesPrior: 'ThreatenedFamilyTimesPrior' } },
    { label: 'Threatened to kidnap child(ren)', labelSpanish: 'Amenazado con secuestrar niño(s)', controls: { has: 'HasThreatenedKidnap', hasOther: 'HasThreatenedKidnapOther', withChild: 'HasThreatenedKidnapWithChild', times: 'ThreatenedKidnapTimes', timesPrior: 'ThreatenedKidnapTimesPrior' } },
    { label: 'Threatened to hurt the other party', labelSpanish: 'Amenazado con lastimar a la otra parte', controls: { has: 'HasThreatenedParty', hasOther: 'HasThreatenedPartyOther', withChild: 'HasThreatenedPartyWithChild', times: 'ThreatenedPartyTimes', timesPrior: 'ThreatenedPartyTimesPrior' } }
  ];

  constructor(private _formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.psychologicalAbuseForm = this._formBuilder.group({
      HasInsulted: [null],
      HasInsultedOther: [null],
      HasInsultedWithChild: [null],
      InsultedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      InsultedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasInterrupt: [null],
      HasInterruptOther: [null],
      HasInterruptWithChild: [null],
      InterruptTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      InterruptTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThreatenedLeave: [null],
      HasThreatenedLeaveOther: [null],
      HasThreatenedLeaveWithChild: [null],
      ThreatenedLeaveTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThreatenedLeaveTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThreatenedMoney: [null],
      HasThreatenedMoneyOther: [null],
      HasThreatenedMoneyWithChild: [null],
      ThreatenedMoneyTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThreatenedMoneyTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasNoContact: [null],
      HasNoContactOther: [null],
      HasNoContactWithChild: [null],
      NoContactTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      NoContactTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasLocked: [null],
      HasLockedOther: [null],
      HasLockedWithChild: [null],
      LockedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      LockedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasWhereabouts: [null],
      HasWhereaboutsOther: [null],
      HasWhereaboutsWithChild: [null],
      WhereaboutsTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      WhereaboutsTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasDisabledCar: [null],
      HasDisabledCarOther: [null],
      HasDisabledCarWithChild: [null],
      DisabledCarTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      DisabledCarTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThreatenedFamily: [null],
      HasThreatenedFamilyOther: [null],
      HasThreatenedFamilyWithChild: [null],
      ThreatenedFamilyTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThreatenedFamilyTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThreatenedKidnap: [null],
      HasThreatenedKidnapOther: [null],
      HasThreatenedKidnapWithChild: [null],
      ThreatenedKidnapTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThreatenedKidnapTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThreatenedParty: [null],
      HasThreatenedPartyOther: [null],
      HasThreatenedPartyWithChild: [null],
      ThreatenedPartyTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThreatenedPartyTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
    });

    this.hasValidPsychologicalAbuse.emit(this.psychologicalAbuseForm.valid);

    this.psychologicalAbuseForm.statusChanges.subscribe((res) => {
      this.hasValidPsychologicalAbuse.emit(this.psychologicalAbuseForm.valid);
    });

    this.psychologicalAbuseForm.valueChanges.subscribe((res) => {
      this.data.emit(res);
    });

    this.nullControls.forEach((controlName) => this.subscribeToValueChanges(controlName));

    this.addConditionalValidators();
  }

  private subscribeToValueChanges(controlName: string): void {
    this.psychologicalAbuseForm.get(controlName).valueChanges.subscribe(value => {
      const newValue = value ? "true" : null;
      if (this.psychologicalAbuseForm.get(controlName).value !== newValue) {
        this.psychologicalAbuseForm.get(controlName).setValue(newValue, { emitEvent: false });
      }
    });
  }

  private addConditionalValidators(): void {
    const abuseTypes = [
      'Insulted', 'Interrupt', 'ThreatenedLeave', 'ThreatenedMoney',
      'NoContact', 'Locked', 'Whereabouts', 'DisabledCar', 'ThreatenedFamily',
      'ThreatenedKidnap', 'ThreatenedParty'
    ];

    abuseTypes.forEach((type) => {
      const hasControlNames = [
        `Has${type}`, `Has${type}Other`, `Has${type}WithChild`
      ];
      const timesControl = this.psychologicalAbuseForm.get(`${type}Times`);
      const timesPriorControl = this.psychologicalAbuseForm.get(`${type}TimesPrior`);

      hasControlNames.forEach((controlName) => {
        this.psychologicalAbuseForm.get(controlName).valueChanges.subscribe(() => {
          const anyChecked = hasControlNames.some(name => this.psychologicalAbuseForm.get(name).value);

          if (anyChecked) {
            timesControl.setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)$/)]);
            timesPriorControl.setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)$/)]);
          } else {
            timesControl.setValidators([Validators.pattern(/^(0|[1-9]\d*)$/)]);
            timesPriorControl.setValidators([Validators.pattern(/^(0|[1-9]\d*)$/)]);
          }

          timesControl.updateValueAndValidity();
          timesPriorControl.updateValueAndValidity();
        });
      });
    });
  }
}
